/* eslint-disable no-unused-vars */
import { login, getClientTempticket, webLogin, logout, userInfo, checkToken, refreshToken, checkTempToken } from '@/api/login'
import { getToken, setToken, removeToken, getRefreshToken, setRefreshToken, removeRefreshToken, getStorage, setStorage, removeStorage } from '@/utils/auth'
import { userOperaRights } from "@/api/user/user";
import { md5 } from '@/utils/encrypt'
const clientId = "f10f162e-3945-4183-b2b9-f7afe472615f";
const user = {
  state: {
    authenticated: false,
    // token: getToken(),
    userInfo: {
      name: null,
      avatar: null,
      email: null,
      gender: null,
      mobile: null,
      profile: null,
      username: null,
      user_number: null,
      user_file_count: 0,
      user_share_count: 0,
      user_group_count: 0,
      is_backup_file: false,
      group_number: null,
      user_type: null,
      rights: {
        has_all_right: 0,
        api_list: {}
      } // 临时用户权限
    }
  },
  mutations: {
    // SET_TOKEN: (state, token) => {
    //   state.token = token
    // },
    SET_AUTH: (state, payload) => {
      state.authenticated = payload
    },
    SET_USER: (state, user) => {
      state.userInfo.group_number = user.user_group_id
      state.userInfo.name = user.name
      state.userInfo.avatar = user.avatar
      state.userInfo.email = user.email
      state.userInfo.mobile = user.mobile
      state.userInfo.gender = user.gender
      state.userInfo.profile = user.profile
      state.userInfo.user_file_count = user.user_file_count
      state.userInfo.user_share_count = user.user_share_count
      state.userInfo.user_group_count = user.user_group_count
      state.userInfo.username = user.username
      state.userInfo.user_number = user.user_number
      state.userInfo.is_backup_file = user.is_backup_file
      state.userInfo.user_type = user.user_type
    },
    SET_USER_RIGHTS: (state, payload) => {
      state.userInfo.rights = payload
      // state.userInfo.rights.api_list['folder/tree'].has_right = 1
    }
  },
  actions: {
    // 登录（测试），仅保存用户token
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password).then(response => {
          if (response.status_code === 200) {
            let res = response.entity
            setToken(res.x_auth_token)
            // commit('SET_TOKEN', res.x_auth_token)
            // setRefreshToken(res.refresh_token)
          }
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 登录（正式）
    webLogin ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getClientTempticket(clientId).then(response => {
          if (response.status_code === 200) {
            let jsonData;
            switch (payload.type) {
              // 【cas:中科大统一身份认证登录】
              case "cas":
                jsonData = {
                  service: payload.service,
                  ticket: payload.ticket,
                  device_type: "pc",
                  client_terminal_type: 'web',
                  type: "cas"
                };
                break;
              // 【account:睿客网用户名密码】
              default:
                jsonData = {
                  username: payload.username,
                  password: md5(response.entity.tempticket + payload.password),
                  device_type: "pc",
                  client_terminal_type: 'web',
                  type: "account"
                };
                break;
            }
            // console.log(jsonData)
            webLogin({
              tempticket: response.entity.tempticket,
              jsonData: jsonData
            }).then(res => {
              if (res.status_code === 200) {
                // 设置存储
                setStorage(res.entity.storage)
                // 设置Token
                setToken(res.entity.x_auth_token)
                // 设置RefreshToken
                setRefreshToken(JSON.stringify({
                  refresh_token: res.entity.refresh_token,
                  token_expire_time: res.entity.authtoken_expire_time,
                }))
                // commit('SET_TOKEN', res.entity.x_auth_token)
              }
              resolve(res)
            }).catch(err => {
              reject(err)
            })
          } else {
            reject(response)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    // PC跳转到Web端
    LoginFromPc ({ commit }, temp_token) {
      return new Promise((resolve, reject) => {
        checkTempToken({
          temp_token: temp_token,
          clientid: clientId
        }).then(res => {
          if (res.status_code === 200) {
            // 设置存储
            setStorage(res.entity.storage)
            // 设置Token
            setToken(res.entity.x_auth_token)
            // 设置RefreshToken
            setRefreshToken(JSON.stringify({
              refresh_token: res.entity.refresh_token,
              token_expire_time: res.entity.authtoken_expire_time,
            }))
            // commit('SET_TOKEN', res.entity.x_auth_token)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 获取用户信息
    UserInfo ({ commit, dispatch }) {
      return new Promise((resolve) => {
        userInfo().then(res => {
          commit('SET_AUTH', true)
          commit('SET_USER', res.entity)
          // commit('SET_GROUP_NUMBER', res.entity.user_group_id)
          if (res.entity.user_type === 3) {
            // 临时用户，获取临时用户权限
            dispatch('UserOperaRights')
          }
          resolve(res)
        }).catch(() => {
          dispatch('RefreshToken')
        })
      })
    },

    // 获取临时用户权限
    UserOperaRights ({ commit }) {
      return new Promise((resolve) => {
        userOperaRights().then(res => {
          commit('SET_USER_RIGHTS', res.entity)
          resolve(res)
        })
      })
    },

    // 刷新token
    RefreshToken ({ commit }) {
      let refresh_token = getRefreshToken() ? JSON.parse(getRefreshToken()).refresh_token : null;
      return new Promise((resolve, reject) => {
        refreshToken({
          clientid: clientId,
          refresh_token: refresh_token
        }).then(res => {
          if (res.status_code === 200) {
            // console.log('更新token了')
            // 设置存储
            setStorage(res.entity.storage)
            // 设置Token
            setToken(res.entity.x_auth_token)
            // 设置RefreshToken
            setRefreshToken(JSON.stringify({
              refresh_token: res.entity.refresh_token,
              token_expire_time: res.entity.authtoken_expire_time,
            }))
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 退出登录
    LogOut ({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          // commit('SET_TOKEN', null)
          commit('SET_AUTH', false)
          commit('SET_USER', {
            name: null,
            avatar: null,
            email: null,
            username: null,
            user_number: null
          })
          // 删除Token
          removeToken()
          // 删除RefreshToken
          removeRefreshToken()
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default user